export const ACTIONS_OZON_ORDERS = {
  ADD_MAP: 'ADD_MAP_OZON',
  CHANGE_OZON_ORDER_MAP: 'CHANGE_OZON_ORDER_MAP',
};

export const addOzonOrdersMap = map => ({
  type: ACTIONS_OZON_ORDERS.ADD_MAP,
  map,
});

export const changeOzonOrdersMap = item => ({
  type: ACTIONS_OZON_ORDERS.CHANGE_OZON_ORDER_MAP,
  item,
});